<template>
  <div class="ibox" style="height: 100%">
    <div class="ibox-title">
      Cadastrar estabelecimento
    </div>

    <div class="ibox-content">

      <div class="form-group">
        <button :disabled="!thereIsParentCompany" class="btn btn-outline btn-md"
                @click="currentCompany.type = 'parent'"
                :class="{ 'btn-active': currentCompany.type === 'parent' }">
          MATRIZ
        </button>
        <button :disabled="!thereIsParentCompany" class="btn btn-outline ml-2 btn-md"
                @click="currentCompany.type = 'subsidiary'"
                :class="{ 'btn-active': currentCompany.type !== 'parent' }">
          FILIAL
        </button>
      </div>

      <div class="form-group">
        <label for="name_company">Razão Social*</label>
        <input v-model="currentCompany.name" type="text" class="form-control" id="name_company" aria-describedby="emailHelp">
      </div>
      <div class="form-group">
        <label for="cnpj_company">CNPJ*</label>
        <input v-model="currentCompany.cnpj" type="text" class="form-control" id="cnpj_company" v-mask="'XX.XXX.XXX/XXXX-##'">
      </div>

      <div class="form-group">
        <label for="ie-company" v-tooltip.left="infoIE()">
          I.E. <info-icon size="1x"/>
        </label>
        <input v-model="currentCompany.ie" type="text" class="form-control" id="ie-company">
      </div>

      <div class="form-group">
        <label for="im-company">I.M.</label>
        <input v-model="currentCompany.im" type="text" class="form-control" id="im-company">
      </div>

      <div class="form-group">
        <label for="state-company">UF*</label>
        <StatesSelect v-model="currentCompany.uf" id="state-company" class="custom-select"/>
      </div>

      <div class="form-group">
        <label for="code-city-company">Cidade*</label>
        <CitySelect v-model="currentCompany.cityCode" :code-uf="currentCompany.uf" id="code-city-company" class="custom-select"/>
      </div>

      <div class="form-group">
        <button @click="clear" class="btn btn-link">Limpar campos</button>
        <button @click="$emit('saveCompany', currentCompany)"
                :disabled="disabledSaveButton" class="btn btn-primary btn-md float-right">
          {{ saveButton }}
        </button>
      </div>

    </div>

  </div>

</template>

<script>
  import StatesSelect from '@/components/shares/specialTag/StatesSelect'
  import CitySelect from '@/components/shares/specialTag/CitySelect'
  import { mask } from 'vue-the-mask'
  import { InfoIcon } from 'vue-feather-icons'

  export default {
    components: { CitySelect, InfoIcon, StatesSelect },
    computed: {
      disabledSaveButton() {
        let cnpjChars = this.currentCompany.cnpj && this.currentCompany.cnpj.match(/[0-9A-Za-z]/g)

        return  !this.currentCompany.uf ||
            !this.currentCompany.name ||
            !this.currentCompany.cityCode ||
            !(cnpjChars && cnpjChars.length === 14)
      }
    },
    created() {
      this.clear()
    },
    data() {
      return {
        currentCompany: {}
      }
    },
    directives: { mask },
    methods: {
      clear() {
        this.currentCompany = {...this.company, type: 'parent'}
      },
      infoIE() {
        return 'Caso este campo não seja preenchido, iremos considerar o estabelecimento como isento, ok?'
      }
    },
    name: 'FormWizard',
    props: {
      company: { required: true, type: Object },
      saveButton: { default: 'Salvar', type: String },
      thereIsParentCompany: { default: false, type: Boolean }
    },
    watch: {
      company(value) {
        this.currentCompany = {...value, type: 'parent'}
      }
    }
  }
</script>

<style scoped>
  .btn-link {
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #5377D6;
  }

  .btn-active {
     background: #192549;
     color: white;
   }

</style>
